module.exports = __webpack_public_path__ + "static/media/Museo-Thyssen-Bornemisza.0ba42a90.jpg";